import { TopicBase } from 'src/app/core/models/i-topic-base';
import { IContentPinned } from './i-content-pinned';
import { Tag } from './i-tag';

export interface IContentList {
  website: string[];
  name: string;
  contentListType: string;
  lastModifiedDateTime: Date;
  contentPinned: IContentPinned[];
  id: string;
  deliveryTargetCodes: string[];
  description: string;
  cas: string;
  topics: TopicBase[];
  tags: Tag[];
}

export class ContentList implements IContentList {
  constructor(
    public website: string[] = [],
    public name: string = '',
    public contentListType: string = '',
    public lastModifiedDateTime: Date = new Date(),
    public contentPinned: IContentPinned[] = [],
    public id: string = '',
    public deliveryTargetCodes: string[] = [],
    public description: string = '',
    public cas: string = '',
    public topics: TopicBase[] = [],
    public tags: Tag[] = [],
  ) {}
}
